export const TELEGRAM_BOT_USERNAME = window.TELEGRAM_BOT_USERNAME || 'glitchlings_bot';

export const TYPE_NAMES = {
  glitch: 'Глитч',
  null: 'Пустота',
  crypto: 'Крипто',
  noise: 'Шум',
  code: 'Код',
  signal: 'Сигнал',
  order: 'Порядок',
  omega: 'Ω-Ошибка'
};

export const DEFAULT_COMBAT_STATS = {
  hp: 100,
  attack: 20,
  defense: 15,
  speed: 10,
  critChance: 0.05,
  energy: null
};

export const BATTLE_STAT_CAPS = {
  hp: 220,
  attack: 40,
  defense: 40,
  speed: 30,
  energy: 120
};

export const ERRORBORN_STORY = [
  'Собери семь фрагментов, которые Errorborn оставил в своих детях. Каждый код — это трещина в Стеке.',
  'Когда все фрагменты собраны, The Stack начинает мигать красным. Это портал — его нужно открыть вручную.',
  'Errorborn не продаётся и не дарится. Он приходит только к тем, кто выдержал все глитчи.',
  'После призыва Errorborn ты получишь доступ к его хроникам и легендарным умениям.'
];

export const MAX_AUTH_RETRY_DELAY = 15000;
export const ERRORBORN_STATUS_TTL = 30000;
export const ERRORBORN_STATUS_CACHE_KEY = 'errorborn-status';

export const BATTLE_AI_TEMPLATES = [
  {
    id: 'ai_bitcor',
    label: 'Bitcor • Glitch',
    previewImage: '/creatures/133.png',
    summary: 'Фрагментирует память противника и наказывает за спам способностями.',
    highlightTitle: 'Core Dump',
    combatant: {
      baseId: 'bitcor',
      creature: {
        baseStats: { hp: 80, attack: 25, defense: 15, speed: 12 },
        types: ['glitch']
      }
    }
  },
  {
    id: 'ai_pixfer',
    label: 'Pixfer • Glitch/Code',
    previewImage: '/creatures/134.png',
    summary: 'Смешивает код и глитчи, чтобы атаковать приоритетно и ломать защиту.',
    highlightTitle: 'Pixel Strike',
    combatant: {
      baseId: 'pixfer',
      creature: {
        baseStats: { hp: 70, attack: 20, defense: 12, speed: 14 },
        types: ['glitch', 'code']
      }
    }
  },
  {
    id: 'ai_nulling',
    label: 'Nulling • Null',
    previewImage: '/creatures/135.png',
    summary: 'Поглощает урон, накапливая пустоту и отвечая контратаками.',
    highlightTitle: 'Null Collapse',
    combatant: {
      baseId: 'nulling',
      creature: {
        baseStats: { hp: 90, attack: 18, defense: 20, speed: 8 },
        types: ['null']
      }
    }
  },
  {
    id: 'ai_crypto',
    label: 'Крипто • Crypto',
    previewImage: '/creatures/136.png',
    summary: 'Использует криптографические алгоритмы для защиты и атаки.',
    highlightTitle: 'Crypto Strike',
    combatant: {
      baseId: 'crypto',
      creature: {
        baseStats: { hp: 75, attack: 22, defense: 18, speed: 15 },
        types: ['crypto']
      }
    }
  },
  {
    id: 'crypto',
    label: 'Крипто • Crypto',
    previewImage: '/creatures/136.png',
    summary: 'Использует криптографические алгоритмы для защиты и атаки.',
    highlightTitle: 'Crypto Strike',
    combatant: {
      baseId: 'crypto',
      creature: {
        baseStats: { hp: 75, attack: 22, defense: 18, speed: 15 },
        types: ['crypto']
      }
    }
  },
  {
    id: 'glitch',
    label: 'Глитч • Glitch',
    previewImage: '/creatures/137.png',
    summary: 'Классический глитч-противник с балансом атаки и защиты.',
    highlightTitle: 'Glitch Strike',
    combatant: {
      baseId: 'glitch',
      creature: {
        baseStats: { hp: 80, attack: 25, defense: 15, speed: 12 },
        types: ['glitch']
      }
    }
  },
  {
    id: 'ai_glitch',
    label: 'Глитч • Glitch',
    previewImage: '/creatures/137.png',
    summary: 'Классический глитч-противник с балансом атаки и защиты.',
    highlightTitle: 'Glitch Strike',
    combatant: {
      baseId: 'glitch',
      creature: {
        baseStats: { hp: 80, attack: 25, defense: 15, speed: 12 },
        types: ['glitch']
      }
    }
  }
];
